import { FullTask, taskStatusByCode } from 'entities';

import { Dot, Row } from 'components/Blocks';

import { TaskDateChangeForm } from 'pages/Projects/components';
import { ContentCard, ProjectLink } from '../components';

import { useLocalPendingEntries } from 'providers/PendingActions';

export function TaskDateChanges(): JSX.Element {
  const tasksToReview = useLocalPendingEntries('TASK_DATE_CHANGE');

  return (
    <>
      {tasksToReview.map((task) => (
        <ContentCard
          key={task.id}
          content={<TaskDateChangeForm task={task as FullTask} />}
          header={
            <Row className="phone:flex-col phone:items-start" gap="2">
              <Row gap="2">
                <Dot size={16} color={taskStatusByCode[task.status].color} />

                <span>{task.name}</span>
              </Row>

              <ProjectLink id={task.projectId} text={`in ${task.projectName}`} />
            </Row>
          }
        />
      ))}
    </>
  );
}
